<template>
  <div>
    <van-nav-bar
      :border="false"
      title="查农资"
      left-arrow
      @click-left="$router.back()"
    />
    <div class="main-container">
      <div class="header">
        <div class="search-type">
          <router-link
            v-for="(i,key) in agrTypeOptions"
            :key="key"
            :to="{name:'ToolAgricultureSearch',params:{type:key}}"
            class="item"
          >
            <svg-icon :class="key" :style="{color:i.color}" :icon-class="i.icon" />
            <p>查{{ i.label }}</p>
          </router-link>
        </div>
      </div>
      <div class="scan-container">
        <div class="scan">
          <div class="box-container">
            <div class="corner1" />
            <div class="corner2" />
            <div class="corner3" />
            <div class="corner4" />
            <div class="line-container">
              <div class="line" />
            </div>
          </div>
        </div>
      </div>
      <div class="scan-describe">
        <span>农药扫一扫辨真假</span>
      </div>
      <div class="tips">
        <p>温馨提示:</p>
        <p>❶扫一扫功能只适用于国家规定的2018年1月1日以后生产的农药标签二维码,使用扫一扫功能之前请看清楚包装上的生产日期</p>
        <p>❷如若瓶身二维码为厂家官方公众号二维码,则不能识别</p>
      </div>
    </div>
  </div>
</template>

<script>
import { agrTypeOptions } from '@/constant/common'

export default {
  name: 'AgricultureIndex',
  data() {
    return {
      agrTypeOptions
    }
  }
}
</script>

<style lang="less" scoped>
.van-nav-bar {
  background: @primary-color;
  ::v-deep {
    .van-nav-bar__title,
    .van-nav-bar__left .van-icon {
      color: #fff;
    }
  }
}
.main-container {
  background: #fff;
}
.header {
  position: relative;
  height: 90px;
  background-color: @primary-color;
  .search-type {
    position: absolute;
    left: 5%;
    right: 5%;
    top: 25%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-items: center;
    background: #fff;
    border-radius: 3px;
    box-shadow: 0 5px 30px -5px #ccc;
    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 85px;
      color: #333;
      font-size: 12px;
      &:active {
        background: #efefef;
      }
      .svg-icon {
        width: 30px;
        height: 30px;
      }
      p {
        line-height: 25px;
        margin: 0;
      }
    }
  }
}
.scan-container {
  padding-top: 140px;
  display: flex;
  justify-content: center;
  .scan {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    background: linear-gradient(rgba(129, 211, 22, 1), rgba(94, 182, 36, 1));
    animation: box_shadow .8s linear infinite alternate;
    .box-container {
      position: relative;
      width: 70px;
      height: 70px;
      border-radius: 2px;
      overflow: hidden;
      div {
        position: absolute;
        width: 15px;
        height: 15px;
        box-sizing: border-box;
        border-radius: 2px;
      }
      .corner1 {
        left: 0;
        top: 0;
        border-left: 5px solid #fff;
        border-top: 5px solid #fff;
      }
      .corner2 {
        top: 0;
        right: 0;
        border-right: 5px solid #fff;
        border-top: 5px solid #fff;
      }
      .corner3 {
        bottom: 0;
        left: 0;
        border-left: 5px solid #fff;
        border-bottom: 5px solid #fff;
      }
      .corner4 {
        bottom: 0;
        right: 0;
        border-right: 5px solid #fff;
        border-bottom: 5px solid #fff;
      }
      .line-container {
        width: 58px;
        height: 20px;
        margin: 0 6px;
        overflow: hidden;
        animation: move_line 2s ease infinite;
        position: relative;
        .line {
          position: absolute;
          bottom: 0;
          background: #fff;
          width: 100%;
          height: 5px;
          box-shadow: 0 0 19px 2px #fff;
        }
      }
    }
  }
}
@keyframes box_shadow {
  from {
    box-shadow: none;
  }
  to {
    box-shadow: 0 0 0 10px rgba(129, 211, 22, .4);
  }
}
@keyframes move_line {
  from {}
  to {
    transform: translateY(44px);
  }
}
.scan-describe {
  text-align: center;
  margin-top: 20px;
  color: #333;
  span {
    padding: 2px 10px;
    border-radius: 20px;
    display: inline-block;
    background: #f2f2f2;
    font-size: 12px;
  }
}
.tips {
  margin: 25px 15px 15px;
  padding: 15px!important;
  border: 1px solid #bbb;
  border-radius: 4px;
  min-height: 120px;
  background: #fff;
  font-size: 12px;
  color: #bbb;
  p{
    margin: 0;
    text-align: left;
  }
}
</style>
